import { useContext } from 'react';

import {
	BookOutlined,
	DownloadOutlined,
	EllipsisOutlined,
	InfoCircleOutlined,
	ReloadOutlined,
	RestOutlined,
	SyncOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown, message } from 'antd';

import {
	useAddRemoveFromFavorites,
	useArchivePost,
	useShareAnalysis,
} from '@/api/batch_process';
import { useDeleteVideoFromCollection } from '@/api/monitor_collections';
import getCanUserArchiveCopilotPosts from '@/lib/helpers/getCanUserArchiveCopilotPosts';
import { CollectionContext } from '@/providers/CollectionsContextProvider';
import { PageContext } from '@/providers/PageContextProvider';

type TProps = {
	record: any;
	isLoading?: boolean;
	onReprocessClick: (record: any) => void;
	onDownloadClick: (record: any) => void;
	onArchiveClick: (record: any) => void;
};

interface IResponseError {
	response: {
		data: {
			message: string;
			error: string;
		};
	};
	message: string;
}

export default function BatchMultiButton({
	record,
	isLoading,
	onReprocessClick,
	onDownloadClick,
	onArchiveClick,
}: TProps) {
	// const { setIsDrawerOpen, setHistoryItem, historyItemId } = useHistoryStore();
	const { drawer, closeDrawer, openDrawer } = useContext(PageContext);
	const { setIsAddToCollectionModalOpen, setModalData } =
		useContext(CollectionContext);

	const {
		mutate: shareVideo,
		isLoading: isShareLoading,
		isSuccess: isShareSuccess,
		data,
	} = useShareAnalysis();

	const { mutate: archivePost, isLoading: isArchiveLoading } = useArchivePost();

	// const onDeleteVideoItemClick = () => {
	// 	deleteVideoItem(
	// 		{
	// 			collection_id: record?.user_video_collection_id,
	// 			post_id: record?.copilot_post_id ?? record?.id,
	// 		},
	// 		{
	// 			onSuccess: () => {
	// 				message.success('Removed');
	// 			},
	// 			onError: (error: any) => {
	// 				const err = error as IResponseError;
	// 				message.error(
	// 					`Something went wrong. Please try again: ${
	// 						err?.response?.data?.message || err?.message
	// 					}`,
	// 				);
	// 			},
	// 		},
	// 	);
	// };

	const handleMenuClick: MenuProps['onClick'] = (e) => {
		// console.log("click", e);

		switch (e.key) {
			case 'view_report':
				openDrawer('view-batch-process-report', record);
				break;
			case 'view_details':
				openDrawer('view-batch-process-details', record);
				break;
			case 'download':
				onDownloadClick(record);
				break;
			case 'archive':
				onArchiveClick(record);
				break;
			case `reprocess`:
				onReprocessClick(record);
				break;
			// case 'delete':
			// 	onDeleteVideoItemClick();

			// message.info("Coming soon... ☺️");
			// break;
			default:
				break;
		}
	};

	const items: MenuProps['items'] = [
		{
			label: 'View report',
			key: 'view_report',
			icon: <BookOutlined style={{ fontSize: '14px' }} />,
			disabled: record?.status !== 'ready',
		},
		{
			label: 'View details',
			key: 'view_details',
			icon: <InfoCircleOutlined style={{ fontSize: '14px' }} />,
		},
		{
			label: 'Reprocess',
			key: 'reprocess',
			icon: <ReloadOutlined style={{ fontSize: '14px' }} />,
			disabled: !['cancelled', 'timeout', 'error'].includes(record.status),
		},
		{
			label: 'Download json',
			key: 'download',
			icon: <DownloadOutlined style={{ fontSize: '14px' }} />,
			disabled: record?.status !== 'ready',
		},
		{
			label: 'Archive',
			key: 'archive',
			icon: <RestOutlined style={{ fontSize: '14px' }} />,
			disabled: ![
				'cancelled',
				'processing',
				'timeout',
				'error',
				'ready',
			].includes(record.status),
			danger: true,
		},
	];

	const menuProps = {
		items: items,
		onClick: handleMenuClick,
	};

	return (
		<Dropdown menu={menuProps} placement="bottomRight">
			<Button
				// size="middle"
				size="small"
				// disabled={
				//   isAddToFavouritesLoading ||
				//   isShareLoading ||
				//   isDeleteLoading ||
				//   isArchiveLoading
				// }
			>
				{isLoading ? <SyncOutlined spin /> : <EllipsisOutlined />}
			</Button>
		</Dropdown>
	);
}
